import {AbstractService} from 'services/AbstractService';

const AVAILABLE_METRICS_LIST_URL = 'api/repos/metrics';

const ACCOUNT_ORDER_METRICS_LIST_URL = '/api/ordermetrics';
const ACCOUNT_ORDER_PERIOD_METRICS_LIST_URL = '/api/orderperiodmetrics';
const ACCOUNT_CUSTOM_METRICS_LIST_URL = 'api/account/custommetrics';

const PROJECT_ORDER_METRICS_LIST_URL = '/api/projects/{0}/ordermetrics';
const PROJECT_ORDER_PERIOD_METRICS_LIST_URL = '/api/projects/{0}/orderperiodmetrics';
const PROJECT_CUSTOM_METRICS_LIST_URL = 'api/projects/{0}/custommetrics';


export class MetricsService extends AbstractService {
  async getAvailableMetrics () {
    return this.client.get(AVAILABLE_METRICS_LIST_URL);
  }

  async getProjectCustomMetrics (accountId, projectId) {
    return (await this.client.get(PROJECT_CUSTOM_METRICS_LIST_URL.format(projectId), {}, {accountId})).items;
  }

  async getAccountCustomMetrics (accountId) {
    return (await this.client.get(ACCOUNT_CUSTOM_METRICS_LIST_URL, {}, {accountId})).items;
  }

  getProjectOrderMetrics (accountId, projectId) {
    return this.client.get(PROJECT_ORDER_METRICS_LIST_URL.format(projectId), {}, {accountId});
  }

  getProjectOrderPeriodMetrics (accountId, projectId) {
    return this.client.get(PROJECT_ORDER_PERIOD_METRICS_LIST_URL.format(projectId), {}, {accountId});
  }

  getAccountOrderMetrics (accountId) {
    return this.client.get(ACCOUNT_ORDER_METRICS_LIST_URL, {}, {accountId});
  }

  getAccountOrderPeriodMetrics (accountId) {
    return this.client.get(ACCOUNT_ORDER_PERIOD_METRICS_LIST_URL, {}, {accountId});
  }

  getProjectAvailableMetrics (accountId, projectId) {
    return this.client.get(PROJECT_ORDER_PERIOD_METRICS_LIST_URL.format(projectId), {}, {accountId});
  }
}
